import { NormalizedGQLError } from '@/common/services/error/types';

type ErrorKey = string; // can be "code", "status:401", or "path:login"

const GENERIC = 'Something went wrong. Please try again.';

// Priority order: exact path match > code match > statusCode match
export const ERROR_MESSAGE_MAP: Record<ErrorKey, string> = {
  // Path-specific
  'path:login:UNAUTHENTICATED': 'Incorrect email or password.',

  // Codes
  'code:UNAUTHENTICATED': 'Please sign in to continue.',
  'code:FORBIDDEN': 'You don’t have permission to do that.',
  'code:BAD_USER_INPUT': 'Please check your inputs and try again.',

  // Status codes
  'status:401': 'Please sign in to continue.',
  'status:400': 'Please check your inputs and try again.',
};

export function lookupErrorMessage(
  norm: NormalizedGQLError,
  raw?: string,
): string {
  // Build keys in order of specificity
  const keys = [
    norm.path && norm.code ? `path:${norm.path}:${norm.code}` : null,
    norm.path ? `path:${norm.path}` : null,
    norm.code ? `code:${norm.code}` : null,
    norm.statusCode ? `status:${norm.statusCode}` : null,
  ].filter(Boolean) as string[];

  for (const key of keys) {
    if (ERROR_MESSAGE_MAP[key]) return ERROR_MESSAGE_MAP[key];
  }

  // Fallback to raw message if short & safe
  if (raw && raw.length <= 120) return raw;

  return GENERIC;
}
